import en from 'src/locale/lang/en.json';
import bg from 'src/locale/lang/bg.json';

// TODO: get from settings
const locale = 'bg';
const messages = { en, bg };

export { locale, messages };
